import { handleActionTypes, type HandleAction, type HandleActionType } from '../../widgets/types';
import { actionLabels } from '../../widgets/action-labels';

type ActionOption = { value: string; label: string; disabled?: boolean };

type HandleActionPredicate = (nodeId: string, handleId: string) => boolean;

export const connectActionLabel = 'Connect to Widget';

const connectOption: ActionOption = { value: '', label: connectActionLabel };

export function allowedActionTypes(
  isZeroRouteAllowed: HandleActionPredicate,
  isOfficeClosedAllowed: HandleActionPredicate,
  nodeId: string,
  handleId: string,
) {
  const allowed: Record<HandleActionType, boolean> = {
    hangup: true,
    zero: isZeroRouteAllowed(nodeId, handleId),
    officeClosed: isOfficeClosedAllowed(nodeId, handleId),
  };
  return handleActionTypes.filter((t) => allowed[t]);
}

export function actionOptions(allowed: HandleActionType[], action: HandleAction | undefined): ActionOption[] {
  const options = allowed.map((t) => ({ value: t, label: actionLabels[t] }));
  if (action && !allowed.includes(action.type)) {
    return [connectOption, ...options, { value: action.type, label: actionLabels[action.type], disabled: true }];
  }
  return [connectOption, ...options];
}
